"use strict";

/** Для внутреннего использования, дабы был принцип DRY
 *
 * @param {string} tokens - токены
*/
var getParameters = function (e, t, r) {
  for (var o = [], n = t.exec(r); n;) decodeURIComponent(n[1]) === e && o.push(decodeURIComponent(n[2])), n = t.exec(r);
  return 1 === o.length ? o[0] : 1 < o.length ? o : "";
};
module.exports = getParameters;